import Vue from 'vue';
import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  login(role, username, password) {
    let user_data = { role, username, password };
    Vue.$logger.debug('[AuthService#login]', user_data);
    return BackendAPI('post', ApiRoutes.auth.login(), user_data);
  },
  googleAuth(token) {
    Vue.$logger.debug('[AuthService#googleAuth]', { token });
    return BackendAPI('post', ApiRoutes.auth.googleAuth(), { token });
  },
  auth() {
    return BackendAPI('get', ApiRoutes.auth.auth());
  },
};
